// AustraliaCompanyRegistration.jsx - FIXED with SYDNEY SKYLINE IMAGE
import React from "react";

export default function AustraliaCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Australia Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Australia Company Registration - ASIC Compliance
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports Australia Company Registration in compliance with ASIC regulations through Form 201.
          </p>
          <p className="text-gray-700">
            Complete ASIC incorporation including Director ID verification, registered office setup, Pty Ltd formation, ACN issuance within 1 business day.
          </p>
        </div>

        {/* Right: SYDNEY HARBOUR BUSINESS SKYLINE - Perfect for ASIC registration */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100 bg-gradient-to-br from-gray-100 to-gray-200">
            <img
              src="https://images.unsplash.com/photo-1544786584-399408640738?w=1200&h=1200&fit=crop&crop=entropy&auto=format&q=85"
              alt="Sydney Australia financial district Opera House skyline for ASIC company registration"
              className="w-full h-[400px] md:aspect-square object-cover block"
              loading="eager"
              onError={(e) => {
                e.target.src = "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1200&h=1200&fit=crop&auto=format&q=85";
              }}
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Australia Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for ASIC approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Director details (Director ID number, passport copies, proof of identity)</li>
                <li>Business activity information (proposed name, ABN eligibility, activities)</li>
                <li>Address proof (registered office address documentation, no PO boxes)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven expertise in ASIC Form 201 lodgements with comprehensive post-incorporation support.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  ASIC Compliance Knowledge
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Corporations Act 2001, Director ID requirements, Pty Ltd rules, continuous disclosure, ASIC Connect portal expertise.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Registration Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise Form 201 preparation, name availability checks, consent declarations, office validations, share structure design, instant ASIC approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Services
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end from name reservation through ACN issuance, ABN/TFN applications, bank introductions, company constitution, first-year compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
